export default __webpack_public_path__ + "static/media/hema.5291c2b1.png";